var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckProgress(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_59021_44669)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.7367 24C9.21294 23.8396 7.79941 23.4185 6.49615 22.7368C5.19289 22.0551 4.06507 21.1729 3.11269 20.0902C2.16031 19.0075 1.41344 17.7744 0.872089 16.391C0.330735 15.0075 0.0600586 13.5439 0.0600586 12C0.0600586 8.89223 1.0776 6.19549 3.11269 3.90977C5.14778 1.62406 7.69916 0.320802 10.7668 0V1.80451C8.20041 2.18546 6.0751 3.33835 4.39089 5.26316C2.70668 7.18797 1.86457 9.43358 1.86457 12C1.86457 14.5664 2.70166 16.812 4.37585 18.7368C6.05003 20.6617 8.17033 21.8145 10.7367 22.1955V24ZM13.3834 24V22.1955C14.3057 22.0752 15.1929 21.8396 16.045 21.4887C16.8972 21.1378 17.6841 20.6717 18.4059 20.0902L19.7292 21.4135C18.8069 22.1153 17.8094 22.6967 16.7367 23.1579C15.6641 23.619 14.5463 23.8997 13.3834 24ZM18.436 3.93985C17.6741 3.3985 16.8721 2.94236 16.03 2.57143C15.1879 2.2005 14.3057 1.94486 13.3834 1.80451V0C14.5463 0.140351 15.6591 0.43609 16.7217 0.887218C17.7844 1.33835 18.7869 1.91479 19.7292 2.61654L18.436 3.93985ZM21.4435 19.5489L20.1503 18.2857C20.7317 17.5439 21.1929 16.7469 21.5337 15.8947C21.8746 15.0426 22.1052 14.1554 22.2255 13.2331H24.0601C23.9197 14.396 23.629 15.5138 23.1879 16.5865C22.7468 17.6591 22.1653 18.6466 21.4435 19.5489ZM22.2255 10.7669C22.1052 9.84461 21.8746 8.95238 21.5337 8.09023C21.1929 7.22807 20.7317 6.43609 20.1503 5.71429L21.5638 4.4812C22.2656 5.40351 22.827 6.39599 23.248 7.45865C23.6691 8.5213 23.9398 9.62406 24.0601 10.7669H22.2255Z",
    fill: "#DAEC37"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.2704 8.26953L10.1538 14.386L7.72959 11.9618L6.42426 13.2672L10.1538 16.9969L17.5757 9.57491L16.2704 8.26953Z",
    fill: "#DAEC37"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_59021_44669"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckProgress);
export default __webpack_public_path__ + "static/media/check_progress.6cc34a9f2c6c5e9585e77bd967881d8a.svg";
export { ForwardRef as ReactComponent };